import {defaultOption, NeshanOptions, TileUrl} from "./options";
import {isEmpty} from "@helpers/helpers";

export const Init = (mapNode, center, zoom, zoom_control, type, tapFullscreen, polygonLocations, options) => {
    let map = null;
    mapNode.innerHTML = '';

    if (typeof type !== "undefined" && type === "neshan") {
        map = new L.Map(mapNode, NeshanOptions(center, zoom, options));
    } else {

        map = new L.Map(mapNode, ((!isEmpty(options)) ? options : defaultOption)).setView(center, zoom);
        L.tileLayer(TileUrl, {
            tileSize: 512,
            zoomOffset: -1,
            attribution: '© <a target="_blank" rel="nofollow" href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(map);

        L.control.attribution({
            position: 'bottomleft'
        }).addTo(map);
    }

    if (polygonLocations) {
        let latlngs = [];

        polygonLocations.map(location => {
            let loc = [location.latitude, location.longitude];
            latlngs.push(loc)
        });

        let polygon = L.polygon(latlngs, {color: '#46d39a'}).addTo(map);

        map.fitBounds(polygon.getBounds())
    }

    if (tapFullscreen) {
		map.on("click", function () {
			if (!isEmpty(map.toggleFullscreen) && !mapNode.classList.contains('leaflet-fullscreen-on') && window.screen.width < 992) {
				map.toggleFullscreen();
			}
		})
    }

    map.on("enterFullscreen", function () {
        if (mapNode.classList) {
            mapNode.classList.add("leaflet-fullscreen-on");
        }

		if (window.screen.width < 992) {
			map.touchZoom.enable();
		}

        if (!isEmpty(options) && !isEmpty(options.dragging) && !options.dragging) {
            map.dragging.enable();
        }

        // if (tapFullscreen) {
        //     // show fullscreen controller when opened
        //     const fullscreenButton = document.querySelector('.leaflet-control-zoom-fullscreen');
        //     if (!isEmpty(fullscreenButton) && fullscreenButton.classList) {
        //         fullscreenButton.classList.remove('d-none');
        //         fullscreenButton.classList.add('d-block')
        //     }
        // }
    });

    map.on("exitFullscreen", function () {
        if (mapNode.classList) {
            mapNode.classList.remove("leaflet-fullscreen-on");
        }

        if (!isEmpty(options) && !isEmpty(options.dragging) && !options.dragging) {
            map.dragging.disable();
        }

		if (window.screen.width < 992) {
			map.touchZoom.disable();
		}

        // if (tapFullscreen) {
        //     // hide fullscreen controller when closed
        //     const fullscreenButton = document.querySelector('.leaflet-control-zoom-fullscreen');
        //     if (!isEmpty(fullscreenButton) && fullscreenButton.classList) {
        //         fullscreenButton.classList.remove('d-block');
        //         fullscreenButton.classList.add('d-none')
        //     }
        // }
    });

    if (zoom_control) {
        L.control
            .zoom({
                position: "topright",
            })
            .addTo(map);
    }

    return map;
};
